import { useEffect, useState } from "react";

/* -------- packages -------- */
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row } from "reactstrap";
import { useTranslation } from "react-i18next";
/* -------- ------- -------- */

/* -------- intern functions -------- */
import { clearDocumentSuccess, clearProductErrors, clearProductSuccess, deleteProductRequest, fetchBrandsRequest, fetchCategoriesRequest, fetchComponentsRequest, fetchProductsRequest, openEditPageProduct } from "../../store/actions";
/* -------- ------- -------- */

/* -------- components -------- */
import TableContainer from "../../components/ui/List/TableContainer";
import Breadcrumb from "../../components/ui/Breadcrumbs";
import Loading from "../../components/ui/Loading";
import ErrorHandler from "../../components/ui/Error/ErrorHandler";
/* -------- ------- -------- */

export default function Catalog () {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const parameters = useSelector(state => state.Parameters);
  const brands = useSelector(state => state.Brands.brands);
  const category = useSelector(state => state.Categories.categories);
  const { productAdded, errorProduct } = useSelector(state => state.Products);

  document.title = `${t('groups')} | ${parameters.appName}`; //meta title

  const [isNewProductModalOpen, setIsNewProductModalOpen] = useState(false);
  const [formattedBrands, setFormattedBrands] = useState([]);
  const [formattedCategories, setFormattedCategories] = useState([]);

  const products = useSelector(state => state.Products.products);
  const { lastDocumentAdded, errorDoc } = useSelector(state => state.Documents);
  
  useEffect(() => {
    dispatch(fetchProductsRequest());
    dispatch(fetchBrandsRequest());
    dispatch(fetchComponentsRequest())
    dispatch(fetchCategoriesRequest())
  }, [dispatch]);


  useEffect(() => {
    if (brands) {
      let newBrands = brands.map((brand) => {
        return {
          id: brand.id,
          label: brand.lib
        }
      });
      setFormattedBrands(newBrands);
    }
  }, [brands]);

  useEffect(() => {
    if (category) {
      let newCategories = category.map((category) => {
        return {
          id: category.id,
          label: category.lib
        }
      });
      setFormattedCategories(newCategories);
    }
  }, [category]);

  // Configuration des colonnes
  const columnConfig = [
    { key: 'id', type: 'text' },
    { key: 'ref', type: 'text'},
    { key: 'lib', type: 'text'},
    { key: 'brandLib', type: 'text'},
    { key: 'categoryLib', type: 'text'},
    { key: 'componentLib', type: 'text'},
    { key: 'nbModules', type: 'text', columnClasses: 'd-flex justify-content-center'},
    { key: 'price', type: 'text', columnClasses: 'd-flex justify-content-center'},
    { key: 'createdAt', type: 'date' },
    { key: 'updatedAt', type: 'date' },
  ];

  // Configuration des filtres
  const filterConfig = [
    { key: 'brandLib', type: 'select', options: formattedBrands },
    { key: 'categoryLib', type: 'select', options: formattedCategories },
  ];

  ErrorHandler(errorProduct, clearProductErrors);

  useEffect(() => {
    if (productAdded) {
      toast.success(t('dataSaved'));
      dispatch(clearProductSuccess());
    }
  }, [productAdded]);

  useEffect(() => {
    if (lastDocumentAdded) {
      toast.success(t('fileImportedSuccessfully'));
      dispatch(clearDocumentSuccess());
    }
  }, [lastDocumentAdded]);

  return (

      <div className="page-content">
        <Container fluid>
          <Breadcrumb breadcrumbItem={t("catalog")}/>

          {(true /* to change */) ?
          (
            <TableContainer
            columnConfig={columnConfig}
            filterConfig={filterConfig}
            data={products}
            tableClass="align-middle table-nowrap table-hover dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
            theadClass="table-light"
            paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
            pagination="pagination"
            divClassName="table-responsive"
            isBordered={true}
            isPagination={true}
            isGlobalFilter={true}
            buttonClass="btn btn-primary btn-rounded waves-effect waves-light addContact-modal mb-2"
            buttonName="newProduct"
            isNewButton={false}
            prefListName="catalog"
            totalKpi={{label: 'numberOfProducts', icon: 'mdi mdi-lightbulb-cfl-spiral'}}
            isAddButton={false}
            linkToNew={'/catalogs/new'}
            editFunction={openEditPageProduct}
            deleteFunction={deleteProductRequest}
            linkedEntityModel={'ProjProduct'}
            withEdit={false}
            isCatalog={true}
            defaultSortColumn={'lib'}
            defaultSortDirection={'asc'}
          />

          ) : (
          <Loading type={"page"} />
        )
          }
        </Container>
        <ToastContainer />
      </div>

  );
};

